import { createReducer } from '@reduxjs/toolkit';

import clearCreateNewOrder, {
  setCreateNewOrderData,
  setCreateNewOrderStep
} from '../../../thunks/coilovers/orders/createNewOrder';

const initialState = {
  loading: false,
  error: null,
  step: 'marketplace',
  checkedSteps: [],
  data: {
    orderId: 'test',
    marketplace: 'affiliate',
    account: 'Billifts',
    orderAssemblyType: {
      label: 'Assembly',
      value: 'Assembly'
    },
    urgencyType: 'Normal',
    orderNotes: '',
    soldDate: '',
    totalPrice: 0,
    title: '',
    npm: '',
    make: '',
    model: '',
    yearRange: '',
    liftPosition: '',
    weights: '',
    width: '',
    height: '',
    length: '',
    checkoutMessage: '',
    noteToClient: '',
    order_assembly_invoice: '',
    order_label_file: '',
    order_label_file2: '',
    referenceNo: '',
    order_assembly_style: null,

    firstName: '',
    lastName: '',
    address: '',
    address2: '',
    country: 'US',
    state: 'AK',
    zip: '',
    city: '',
    phone: '',
    email: '',
    declared: 0
  },
};

const createNewOrderReducer = createReducer(initialState, {
  [setCreateNewOrderStep]: (state, { payload }) => ({
    ...state,
    step: payload,
  }),
  [setCreateNewOrderData]: (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      ...payload
    }
  }),
  [clearCreateNewOrder]: () => initialState
});

export default createNewOrderReducer;
